import { Component, Vue } from "vue-property-decorator";

@Component
export default class ExamDocumentMixin extends Vue {
  public modalId = "theory-exam-document-id";
  public previewModalId = "preview-theory-exam-document-id";
}
